(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-scratch/assets/javascripts/utils/normalize-win.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-scratch/assets/javascripts/utils/normalize-win.js');
"use strict";

setGlobal('svs.ticketgames.ticketScratch.utils.normalizeWin', result => {
  var _result$prize, _result$data;
  const amount = result.wonAmount.value / 100;
  const prizeType = ((_result$prize = result.prize) === null || _result$prize === void 0 ? void 0 : _result$prize.type) || ((_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.eventReference) === null || _result$data === void 0 ? void 0 : _result$data.prizeType);
  return {
    extraicon: prizeType,
    amount,
    game: {},
    winFlag: amount > 0 || Boolean(prizeType)
  };
});

 })(window);